import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import SignatureCanvas from 'react-signature-canvas';
import DropdownDate from "react-dropdown-date";
import {
    isRequiredText,
    conditionallyRequiredSelection,
    isRequiredQuestionSelection,
    conditionallyRequiredText,
    isRequiredDate,
    conditionallyRequiredSignature,
    conditionallyRequiredSignatureDate,
    numberValidator,
    conditionallyRequiredDate,
    conditionallyRequiredPhoneNumber,
    conditionalNumberValidator
} from '../helpers/Validation';
import { textField } from '../helpers/Form';
import {hipaaTextFull} from '../terms/hipaa';
import arrowUp from '../../assets/images/arrow-up.png';
import arrowDown from '../../assets/images/arrow-down.png';
import SignatureDate from '../hooks/SignatureDate';

class Step1 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            patientSignature: null,
            residentPhoneOne: null,
            residentPhoneTwo: null,
            residentPhoneThree: null,
            caregiverPhoneOne: null,
            caregiverPhoneTwo: null,
            caregiverPhoneThree: null,
            dob: null,
            patientSignatureDate: null,
            hipaaTextBox: false
        }
    }

    // Used to restore sigs
    componentDidMount() {
        const { patientSignature } = this.props.questionOptions;

        const options = {
            minWidth: 0.5,
        }
        if (patientSignature) {
            this[("patientSignatureRef")].fromDataURL(patientSignature, options);
        }
    }

    clearSigCanvas = (refName) => {
        this[(refName + "Ref")].clear();
    }

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[(refName + "Ref")].getTrimmedCanvas().toDataURL()
        })
        this.props.questionAnswer(refName, this[(refName + "Ref")].toDataURL());
    }

    toggleTextBox = (name) => {
        this.setState({
            ...this.state,
            [name]: !this.state[name]
        });
        this.hipaaTextBox.current.scrollIntoView({ behavior: "smooth" });
    }

    residentPhoneTwo = createRef();
    residentPhoneThree = createRef();
    caregiverPhoneTwo = createRef();
    caregiverPhoneThree = createRef();
    hipaaTextBox = createRef();

    render() {
        const { currentStep } = this.props;
        const {
            dob,
            gender,
            preferredContact,
            preferredContactTime,
            residentPhoneOne,
            residentPhoneTwo,
            residentPhoneThree,
            caregiverPhoneOne,
            caregiverPhoneTwo,
            caregiverPhoneThree,
            hipaa,
            patientSignatureDate
        } = this.props.questionOptions;
        const {
            patientSignature,
            hipaaTextBox
        } = this.state;

        const todaysDate = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-0">
                        <h3 className="euclid">RESIDENT INFORMATION</h3>
                        <div className="d-inline-block"><i>All questions are required unless marked optional.</i></div>
                        <div className="text-right d-inline-block float-right pr-2">*required</div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                    <Field
                        name="residentFirstName"
                        label="Resident first name*"
                        placeholder="Resident first name"
                        component={textField}
                        validate={isRequiredText}
                    />
                        </div>
                    <div className="col-sm">
                    <Field
                        name="residentLastName"
                        label="Resident last name*"
                        placeholder="Resident last name"
                        component={textField}
                        validate={isRequiredText}
                    />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm">
                        <div className="form-group">
                            <Field name="dob" component="input" defaultValue={dob} validate={isRequiredDate}>
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={(meta.error && meta.touched ? "fancy-label error" : "fancy-label") + ((meta.valid && meta.touched || input.value && meta.valid)? "valid " : " ")}
                                            htmlFor="dob"
                                        >
                                            Date of birth*
                                        </label>
                                        <DropdownDate
                                            onDateChange={date => {
                                                this.props.questionAnswer("dob", date);
                                            }}
                                            order={
                                                ['month', 'day', 'year'] // Order of the dropdowns
                                            }
                                            defaultValues={
                                                {
                                                    month: "Month",
                                                    day: "Day",
                                                    year: "Year"
                                                }
                                            }
                                            selectedDate={dob ? dob : ""}
                                            options={
                                                {
                                                    yearReverse: true
                                                }
                                            }
                                            classes={
                                                {
                                                    month: (meta.error && meta.touched ? "dateDropDownMonthClass error" : "dateDropDownMonthClass"),
                                                    day: (meta.error && meta.touched ? "dateDropDownDayClass error" : "dateDropDownDayClass"),
                                                    year: (meta.error && meta.touched ? "dateDropDownYearClass error" : "dateDropDownYearClass")
                                                }
                                            }
                                        />
                                        <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1"  />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="form-group">
                            <div className="row">
                                <div className="col">
                                    <label>Gender (optional)</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col">
                                                <div className="radio-field">
                                                    <Field
                                                        name="gender"
                                                        component="input"
                                                        type="radio"
                                                        style={{flexShrink: '0'}}
                                                        value="male"
                                                        id="male"
                                                        style={{}}
                                                        onClick={(e) => this.props.questionAnswer("gender", "male")}
                                                    />
                                                    <div style={{display: 'inline-grid'}}>
                                                        <label htmlFor="male">Male</label>
                                                    </div>
                                                </div>
                                                <div className="radio-field">
                                                    <Field
                                                        name="gender"
                                                        component="input"
                                                        type="radio"
                                                        style={{flexShrink: '0'}}
                                                        value="female"
                                                        id="female"
                                                        onClick={(e) => this.props.questionAnswer("gender", "female")}
                                                    />
                                                    <div style={{display: 'inline-grid'}}>
                                                        <label htmlFor="female">Female</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="form-group">
                    <div className="row">
                        <div className="col">
                            <Field
                                name="preferredContact"
                                component="input"
                                defaultValue={preferredContact}
                                validate={ isRequiredQuestionSelection }
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className={meta.error && meta.touched ? "error" : ""}>Preferred contact*</label>
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col">
                                        <div className="radio-field">
                                            <Field
                                                name="preferredContact"
                                                component="input"
                                                type="radio"
                                                style={{flexShrink: '0'}}
                                                value="patient"
                                                id="patient"
                                                onClick={(e) => this.props.questionAnswer("preferredContact", "patient")}
                                                style={{flexShrink: '0'}}
                                            />
                                            <label htmlFor="patient">
                                                Patient
                                            </label>
                                        </div>
                                        <div className="radio-field">
                                            <Field
                                                name="preferredContact"
                                                component="input"
                                                type="radio"
                                                style={{flexShrink: '0'}}
                                                value="caregiver"
                                                id="caregiver"
                                                onClick={(e) => this.props.questionAnswer("preferredContact", "caregiver")}
                                                style={{flexShrink: '0'}}
                                            />
                                            <label htmlFor="caregiver">
                                                Caregiver
                                            </label>
                                        </div>
                                            <Field
                                                name="preferredContact"
                                                component="input"
                                                defaultValue={preferredContact}
                                                validate={isRequiredQuestionSelection}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input className="form-control full-width-input hidden-field" tabindex="-1" {...input} type="text" />
                                                        {meta.error && meta.touched && meta.error }
                                                    </Fragment>
                                                )}
                                            </Field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <label className="fancy-label">Resident phone number (optional)</label>
                        <div className="phone-group">
                            <Field name="residentPhoneOne" component="input" >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className="form-control inline-phone phone-area-code"
                                            type="text"
                                            maxLength={3}
                                            placeholder="123"
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="residentPhoneOne">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("residentPhoneOne", value);
                                        if(value.length === 3) {
                                            this.residentPhoneTwo.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="residentPhoneTwo" component="input" >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className="form-control inline-phone phone-prefix"
                                            type="text"
                                            maxLength={3}
                                            placeholder="456"
                                            ref={this.residentPhoneTwo}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="residentPhoneTwo">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("residentPhoneTwo", value);
                                        if(value.length === 3) {
                                            this.residentPhoneThree.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="residentPhoneThree" component="input">
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            className="form-control inline-phone phone-line-number"
                                            type="text"
                                            maxLength={4}
                                            placeholder="7890"
                                            ref={this.residentPhoneThree}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="residentPhoneThree">
                                {(value, previous) => {
                                    if(numberValidator(value)) {
                                        this.props.questionAnswer("residentPhoneThree", value);
                                    }
                                }}
                            </OnChange>
                        </div>
                        <Field
                            name="residentPhoneNumber"
                            component="input"
                            defaultValue={String(residentPhoneOne + residentPhoneTwo + residentPhoneThree)}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input className="form-control full-width-input hidden-field" tabindex="-1" {...input} type="text" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <div className="col-sm-6">
                            <Field
                                name="residentEmail"
                                label={"Resident email address" + ((preferredContact === "resident" || !preferredContact) ? "*" : " (optional)")}
                                component={textField}
                                validate={conditionallyRequiredText((preferredContact === "resident" || !preferredContact))}
                                key={(preferredContact === ("resident" || !preferredContact) ) ? 1 : 0}
                            />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <Field
                            name="caregiverName"
                            label="Caregiver name (optional)"
                            component={textField}
                        />
                    </div>
                    <div className="col-sm-6">
                        <Field
                            name="caregiverEmail"
                            label={"Caregiver email address" + ((preferredContact === "caregiver" || !preferredContact) ? "*" : " (optional)")}
                            component={textField}
                            validate={conditionallyRequiredText((preferredContact === "caregiver" || !preferredContact))}
                            key={(preferredContact === "caregiver" || !preferredContact) ? 1 : 0}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <Field
                                name="caregiverPhoneNumber"
                                component="input"
                                defaultValue={caregiverPhoneOne + caregiverPhoneTwo + caregiverPhoneThree}
                                validate={conditionallyRequiredPhoneNumber(preferredContact === "caregiver")}
                            >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input className="form-control full-width-input hidden-field" tabindex="-1" {...input} type="text" />
                                    <label className="fancy-label">Caregiver phone number (optional)</label>
                                </Fragment>
                            )}
                        </Field>
                        <div className="phone-group">
                            <Field name="caregiverPhoneOne" component="input">
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            className="form-control inline-phone phone-area-code"
                                            {...input}
                                            type="text"
                                            maxLength={3}
                                            placeholder="123"
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="caregiverPhoneOne">
                                {(value, previous) => {
                                    if(conditionalNumberValidator(value, preferredContact === "caregiver")) {
                                        this.props.questionAnswer("caregiverPhoneOne", value);
                                        if(value.length === 3) {
                                            this.caregiverPhoneTwo.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="caregiverPhoneTwo" component="input" >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            className="form-control inline-phone phone-prefix"
                                            {...input}
                                            type="text"
                                            maxLength={3}
                                            placeholder="456"
                                            ref={this.caregiverPhoneTwo}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="caregiverPhoneTwo">
                                {(value, previous) => {
                                    if(conditionalNumberValidator(value, preferredContact === "caregiver")) {
                                        this.props.questionAnswer("caregiverPhoneTwo", value);
                                        if(value.length === 3) {
                                            this.caregiverPhoneThree.current.focus();
                                        }
                                    }
                                }}
                            </OnChange>
                            <Field name="caregiverPhoneThree" component="input">
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            className="form-control inline-phone phone-line-number"
                                            {...input} type="text"
                                            maxLength={4}
                                            placeholder="7890"
                                            ref={this.caregiverPhoneThree}
                                            inputMode="numeric"
                                        />
                                        {meta.error && meta.touched && meta.error }
                                    </Fragment>
                                )}
                            </Field>
                            <OnChange name="caregiverPhoneThree">
                                {(value, previous) => {
                                    if(conditionalNumberValidator(value, preferredContact === "caregiver")) {
                                        this.props.questionAnswer("caregiverPhoneThree", value);
                                    }
                                }}
                            </OnChange>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <Field
                            name="preferredLanguage"
                            label="Preferred language"
                            component={textField}
                        />
                    </div>
                </div>
                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-small mobile">&nbsp;</div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm">
                            <label>Preferred contact time (optional)</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm">
                            <div className="radio-field">
                                <Field name="preferredContactTime">
                                    {({ input, meta }) => {
                                    return(
                                        <Fragment>
                                            <input
                                                name={input.name}
                                                type="radio"
                                                style={{flexShrink: '0'}}
                                                id="morning"
                                                onClick={(e) => this.props.questionAnswer("preferredContactTime", "Morning")}
                                            />
                                        </Fragment>);
                                }}
                                </Field>
                                <label htmlFor="morning">Morning</label>
                            </div>
                            <div className="radio-field">
                                <Field name="preferredContactTime">
                                    {({ input, meta }) => {
                                    return(
                                        <Fragment>
                                            <input
                                                name={input.name}
                                                type="radio"
                                                style={{flexShrink: '0'}}
                                                id="afternoon"
                                                onClick={(e) => this.props.questionAnswer("preferredContactTime", "Afternoon")}
                                            />
                                        </Fragment>);
                                }}
                                </Field>
                                <div style={{display: 'inline-grid'}}>
                                    <label htmlFor="afternoon">Afternoon</label>
                                </div>
                            </div>
                            <div className="radio-field">
                                <Field name="preferredContactTime">
                                    {({ input, meta }) => {
                                    return(
                                        <Fragment>
                                            <input
                                                name={input.name}
                                                type="radio"
                                                style={{flexShrink: '0'}}
                                                id="evening"
                                                onClick={(e) => this.props.questionAnswer("preferredContactTime", "Evening")}
                                            />
                                        </Fragment>);
                                }}
                                </Field>
                                <div style={{display: 'inline-grid'}}>
                                    <label htmlFor="evening">Evening</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Field
                        name="preferredContactTime"
                        component="input"
                        defaultValue={preferredContactTime}
                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                {meta.error && meta.touched && meta.error }
                            </Fragment>
                        )}
                    </Field>
                </div>
                <div className="row spacer-small">&nbsp;</div>


                <div className="hipaa">
                    <h3 ref={this.hipaaTextBox}>Resident Signature/<wbr/>Legal Guardian HIPAA Authorization (optional)</h3>
                    <div className="row spacer-small" />
                    <div className={"scroll-terms " + (hipaaTextBox ? "expanded" : "condensed")}>
                        {hipaaTextFull}
                    </div>
                    <button className="btn no-outline" onClick={() => this.toggleTextBox("hipaaTextBox")} type="button">
                        SEE {hipaaTextBox ? <Fragment>LESS<img className="arrow" src={arrowUp} alt="arrrow"/></Fragment> : <Fragment>MORE<img className="arrow" src={arrowDown} alt="arrrow" /></Fragment>}
                    </button>
                    <div className="row spacer-small" />
                    {/* <p>By signing this authorization, I authorize my health plans, physicians, long-term care and other health care providers, and pharmacies (collectively "Providers") to disclose my Protected Health Information.</p> */}
                    <div className="relative form-group iphone11-checkboxes-left-15px" style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Field
                            type="checkbox"
                            className="form-control full-width-input"
                            name="agreeToHipaaAuth"
                            component="input"
                            validate={conditionallyRequiredSelection(hipaa || patientSignature || patientSignatureDate ? 1 : 0)}
                            key={hipaa || patientSignature || patientSignatureDate ? 1 : 0}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <div className="row">
                                        <div className="col-2 col-md-1">
                                            <label className="acadia-checkbox">
                                                <input ref={this.agreeToHipaaAuthRef} {...input} type="checkbox" style={{left: "0px"}} />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-10 col-md-11 pl-0">
                                            <label className="mobile-label">
                                                <span className="hipaa-agree">I have read and agree to HIPAA authorization</span>
                                            </label>
                                            {meta.error && meta.touched && meta.error}
                                        </div>
                                    </div>
                                </Fragment>

                            )}
                        </Field>
                        <OnChange name="agreeToHipaaAuth">
                            {(value, previous) => {
                                this.props.questionAnswer("hipaa", value);
                            }}
                        </OnChange>
                    </div>
                    <div className="text-center relative form-group">
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{height: 200, className: 'sig-canvas'}}
                            onEnd={() => this.storeSigData("patientSignature")}
                            ref={(ref) => { this.patientSignatureRef = ref }}
                            clearOnResize={false}
                        />
                        <button type="button" className="canvas-clear" onClick={() => this.clearSigCanvas("patientSignature")}>CLEAR</button>
                        <Field
                            name="patientSignature"
                            defaultValue={patientSignature}
                            component="input"
                            validate={conditionallyRequiredSignature(hipaa || patientSignature || patientSignatureDate ? 1 : 0)}
                            key={hipaa || patientSignature || patientSignatureDate ? 1 : 0}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                    {meta.error && meta.touched && meta.error }
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <SignatureDate forDate="patientSignature"/>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { currentStep, formValues, questionOptions } = state;
    return { currentStep: currentStep, formValues: formValues, questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(Step1);
